"use strict";import{css as s}from"@spectrum-web-components/base";const t=s`
    :host{display:table-header-group}:host .spectrum-Table-scroller{z-index:1;position:sticky;inset-block-start:0}:host{display:flex}
`;export default t;
//# sourceMappingURL=table-head.css.js.map
